// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.App-header {
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
  padding: 40px 20px;
  color: var(--text-primary);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  position: relative;
  overflow: hidden;
}

.App-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 20%, var(--accent-coffee) 0%, transparent 50%),
              radial-gradient(circle at 70% 80%, var(--accent-beige) 0%, transparent 50%);
  opacity: 0.1;
  z-index: 0;
}

.App-header > * {
  position: relative;
  z-index: 1;
}

.App-header h1 {
  margin-bottom: 20px;
  color: var(--accent-coffee);
  font-weight: 600;
  text-shadow: 0 2px 4px var(--shadow-color);
}

.App-header p {
  margin: 10px 0;
  font-size: 18px;
  color: var(--text-primary);
  line-height: 1.6;
}

.App-header code {
  background-color: var(--accent-cream);
  color: var(--text-secondary);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 16px;
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 4px var(--shadow-color);
  transition: all 0.3s ease;
}

.App-header code:hover {
  background-color: var(--accent-beige);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--shadow-color);
}

/* Theme Toggle Button */
.theme-toggle {
  position: fixed;
  top: 20px;
  right: 20px;
  background: var(--accent-coffee);
  color: var(--accent-cream);
  border: 2px solid var(--border-color);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
  box-shadow: 0 4px 12px var(--shadow-color);
}

.theme-toggle:hover {
  background: var(--accent-beige);
  transform: scale(1.1);
  box-shadow: 0 6px 16px var(--shadow-color);
}

.theme-toggle:active {
  transform: scale(0.95);
}

/* Color Palette Demo */
.color-palette-demo {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  flex-wrap: wrap;
  justify-content: center;
}

.color-swatch {
  padding: 15px 25px;
  border-radius: 12px;
  font-weight: 600;
  color: var(--accent-cream);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0 4px 12px var(--shadow-color);
  transition: all 0.3s ease;
  cursor: pointer;
  min-width: 100px;
  text-align: center;
}

.color-swatch:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px var(--shadow-color);
}

.color-swatch.coffee {
  background: var(--accent-coffee);
}

.color-swatch.beige {
  background: var(--accent-beige);
  color: var(--text-primary);
  text-shadow: none;
}

.color-swatch.cream {
  background: var(--accent-cream);
  color: var(--text-secondary);
  text-shadow: none;
  border: 2px solid var(--border-color);
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,mFAAmF;EACnF,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;yFACuF;EACvF,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,qCAAqC;AACvC","sourcesContent":[".App {\n  text-align: center;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.App-header {\n  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);\n  padding: 40px 20px;\n  color: var(--text-primary);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  position: relative;\n  overflow: hidden;\n}\n\n.App-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 30% 20%, var(--accent-coffee) 0%, transparent 50%),\n              radial-gradient(circle at 70% 80%, var(--accent-beige) 0%, transparent 50%);\n  opacity: 0.1;\n  z-index: 0;\n}\n\n.App-header > * {\n  position: relative;\n  z-index: 1;\n}\n\n.App-header h1 {\n  margin-bottom: 20px;\n  color: var(--accent-coffee);\n  font-weight: 600;\n  text-shadow: 0 2px 4px var(--shadow-color);\n}\n\n.App-header p {\n  margin: 10px 0;\n  font-size: 18px;\n  color: var(--text-primary);\n  line-height: 1.6;\n}\n\n.App-header code {\n  background-color: var(--accent-cream);\n  color: var(--text-secondary);\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 16px;\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 4px var(--shadow-color);\n  transition: all 0.3s ease;\n}\n\n.App-header code:hover {\n  background-color: var(--accent-beige);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px var(--shadow-color);\n}\n\n/* Theme Toggle Button */\n.theme-toggle {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  background: var(--accent-coffee);\n  color: var(--accent-cream);\n  border: 2px solid var(--border-color);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  font-size: 20px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1000;\n  box-shadow: 0 4px 12px var(--shadow-color);\n}\n\n.theme-toggle:hover {\n  background: var(--accent-beige);\n  transform: scale(1.1);\n  box-shadow: 0 6px 16px var(--shadow-color);\n}\n\n.theme-toggle:active {\n  transform: scale(0.95);\n}\n\n/* Color Palette Demo */\n.color-palette-demo {\n  display: flex;\n  gap: 20px;\n  margin-top: 30px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.color-swatch {\n  padding: 15px 25px;\n  border-radius: 12px;\n  font-weight: 600;\n  color: var(--accent-cream);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 4px 12px var(--shadow-color);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  min-width: 100px;\n  text-align: center;\n}\n\n.color-swatch:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px var(--shadow-color);\n}\n\n.color-swatch.coffee {\n  background: var(--accent-coffee);\n}\n\n.color-swatch.beige {\n  background: var(--accent-beige);\n  color: var(--text-primary);\n  text-shadow: none;\n}\n\n.color-swatch.cream {\n  background: var(--accent-cream);\n  color: var(--text-secondary);\n  text-shadow: none;\n  border: 2px solid var(--border-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
